import { LoadingOverlay } from "@mantine/core";
import { useEffect }      from "react";

import { initialValidations } from "_common/ssrWrapper";
import { payViaCashfree }     from "_common/utils/cashfree";

const CashfreeGateway = ( { txnToken } ) => {

	useEffect ( () => {
		if ( !txnToken )
			return;

		payViaCashfree ( txnToken );
	}, [ txnToken ] );

	return (
		<LoadingOverlay
			overlayProps          = { { radius: "sm", blur: 2 } }
			visible               = { true }
			zIndex                = { 1000 }
		/>
	);
};

export default CashfreeGateway;

const getServerSideProps = context => initialValidations ( context, async defaultProps => {
	return {
		props: {
			...defaultProps,
			txnToken    : context?.query?.txnToken || "",
			noAuth      : true,
			noLayout    : true,
			noAnalytics : true
		}
	};

} );

export { getServerSideProps };
